import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import App from './App.vue'
import i18n from "@/i18n/i18n";
import router from "@/router/router";
import store from './store'
import './assets/styles/common.scss'
import './assets/styles/tailMain.css'
import moment from 'moment';

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.config.globalProperties.$moment = moment;
app.use(ElementPlus)
app.use(i18n)
app.use(router)
app.use(store)
app.mount('#app')
